module.exports = __webpack_public_path__ + "static/media/Visage.54254c68.png";